import { Box, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { COLORS } from '../../../../utils/Application_Constants';

export default function InvoiceIssuesBanner({
    issues = [],
    hasErrors = false,
    hasWarnings = false,
}) {
    const list = Array.isArray(issues) ? issues.filter((i) => i?.message) : [];
    const showError = hasErrors || list.some((i) => String(i.level).toLowerCase() === 'error');
    const showWarn =
        !showError &&
        (hasWarnings || list.some((i) => String(i.level).toLowerCase() === 'warning'));
    if (!showError && !showWarn) return null;

    const isError = showError;
    const Icon = isError ? ErrorOutlineIcon : WarningAmberIcon;
    const palette = isError
        ? { bg: '#FDECEA', border: '#F1635C', icon: '#D93025' } // error tones
        : { bg: '#FFF7E6', border: '#F6B44B', icon: '#B86E00' }; // warning tones

    return (
        <Box
            sx={{
                px: 2,
                py: 1.5,
                borderRadius: 1,
                bgcolor: palette.bg,
                borderLeft: `4px solid ${palette.border}`,
            }}
        >
            <Stack direction="row" spacing={1.25} alignItems="flex-start">
                <Icon sx={{ color: palette.icon, mt: '2px' }} />
                <Box>
                    <Typography
                        sx={{ fontWeight: 600, fontSize: 13, mb: 0.5, color: COLORS.LT_MIDNIGHT }}
                    >
                        {isError ? 'Errors' : 'Warnings'}
                    </Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2 }}>
                        {list.map((i, idx) => (
                            <li key={idx}>
                                <Typography sx={{ fontSize: 12, color: COLORS.LT_MIDNIGHT75 }}>
                                    {i.message}
                                </Typography>
                            </li>
                        ))}
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
}
